import axios from 'axios';

export const getReports = async (props) => {
  const {
    year,
    number,
    newToken,
    profileId,
    iafs = true,
    forUserView = false,
  } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/network/report/${profileId}`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        number,
        iafs,
        forUserView,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getNetworkReportsBonuses = async (props) => {
  const {
    year,
    number,
    newToken,
    profileId,
    iafs = true,
    forUserView = false,
  } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/network/reports/${profileId}/bonuses`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        number,
        iafs,
        forUserView,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getNetworkReportsVariableRevenuesTotals = async (props) => {
  const {
    year,
    number,
    newToken,
    profileId,
    iafs = true,
    forUserView = false,
  } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/network/reports/${profileId}/variableRevenues/totals`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        number,
        iafs,
        forUserView,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getNetworkReportsVariableRevenuesInsurancesTotals = async (
  props
) => {
  const {
    year,
    number,
    newToken,
    profileId,
    iafs = true,
    forUserView = false,
  } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/network/reports/${profileId}/insuranceRevenues/totals`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        number,
        iafs,
        forUserView,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getNetworkReportsVariableRevenuesEnergyTotals = async (props) => {
  const {
    year,
    number,
    newToken,
    profileId,
    iafs = true,
    forUserView = false,
  } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/network/reports/${profileId}/energyFeeRevenues/totals`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        number,
        iafs,
        forUserView,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getMyReport = async (props) => {
  const { year, number, newToken, profileId } = props;

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/network/my-report`,
      headers: {
        Authorization: newToken,
      },
      params: {
        year,
        number,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};
